"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _Tmall = _interopRequireDefault(require("@rsuite/icon-font/lib/platform/Tmall"));

// Generated by script, don't edit it please.
var Tmall = (0, _createSvgIcon["default"])({
  as: _Tmall["default"],
  ariaLabel: 'tmall',
  category: 'platform',
  displayName: 'Tmall'
});
var _default = Tmall;
exports["default"] = _default;
module.exports = exports.default;